module.exports = {
  "metadata": {
    "width": "18",
    "height": "24",
    "name": "refresh"
  },
  "source": "<path d=\"M16.59 16.19a1 1 0 0 1-1.75-1A6.62 6.62 0 0 0 9 5.43V8L4 4l5-4v3.43a8.62 8.62 0 0 1 7.59 12.76zM9 18.68A6.62 6.62 0 0 1 3.34 8.59a1 1 0 1 0-1.71-1A8.64 8.64 0 0 0 9 20.69V24l5-4-5-4z\"/>"
};